import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import React from "react";
import "./FeatureSelection.scss";

const FeatureSelection = ({ title = "Dashboard", options = [], code, selectedValues = [],
  isFeatureEnabled, setIsFeatureEnabled,
  payloadFeatures, setPayloadFeatures
}) => {
  const disabledOptions = options.filter(option => option.value !== "All" && option.isDisable);
  const individualOptions = options.filter(option => option.value !== "All");

  const handleSelectedOption = (value) => {

    if (!isFeatureEnabled[code]) return;
    if (value !== "All") {
      const filterValue = payloadFeatures[code]?.filter(opt => opt !== value)?.filter(opt => opt != "All");
      const newSelected = payloadFeatures[code] && payloadFeatures[code]?.includes(value)
        ? filterValue
        : [...payloadFeatures[code], value];
      setPayloadFeatures({
        ...payloadFeatures,
        [code]: newSelected.length === individualOptions.length ? [...newSelected, "All"] : newSelected
      });
    } else {
      const newSelected = payloadFeatures[code] && payloadFeatures[code].includes("All")
        ? [...(disabledOptions.map(val => val.value))] : [...(individualOptions.map(val => val.value)), "All"];
     
      setPayloadFeatures({
        ...payloadFeatures,
        [code]: newSelected.includes("All") ? [...newSelected, "All"] : newSelected
      });
    }
  };

  const handleToggle = (e) => {
    setIsFeatureEnabled({
      ...isFeatureEnabled,
      [code]: disabledOptions.map(val => val.value).length > 0 ? !e.target.checked : e.target.checked
    })
    if (!e.target.checked && disabledOptions.map(val => val.value).length == 0) {
      setPayloadFeatures({
        ...payloadFeatures,
        [code]: []
      })
    }
  };

  return (
    <div className="filter-container">
      <div className="filter-header">
        <span className="filter-title">{title}</span>
        <label className="toggleFeature-switch">
          <input type="checkbox" checked={isFeatureEnabled[code]} onChange={handleToggle} />
          <span className="slider"></span>
        </label>
      </div>

      <div className="filter-all">
        <FormControlLabel
         className="custom-form-label"
         componentsProps={{
          typography: { className: "custom-label" },
        }}
          control={
            <Radio
              checked={payloadFeatures[code]?.includes("All")}
              onClick={() => handleSelectedOption("All")}
              color="warning"
              disabled={!isFeatureEnabled[code]}
            />
          }
          label="All"
        />
      </div>

      <hr className="divider" />

      <div className="filter-options">
        {individualOptions.map((option) => (
          <div key={option.value} className={`filter-option ${(payloadFeatures[code]?.includes(option.value) && !option.isDisable) ? "active" : ""}`}>
            <FormControlLabel
               className="custom-form-label"
               componentsProps={{
                typography: { className: "custom-label" },
              }}
              control={
                <Radio
                  checked={payloadFeatures[code]?.includes(option.value,)}
                  onClick={() => handleSelectedOption(option.value)}
                  color="warning"
                  disabled={!isFeatureEnabled[code] || option.isDisable}
                />
              }
              label={option.label}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeatureSelection;
